export const compensationDe = {
    errors: {
        notEnabled: 'Aufwandsentschädigungen sind für diese Organisation nicht eingerichtet.',
        claimNotFound: 'Abrechnung nicht gefunden.',
        profileNotFound: 'Für diesen Kontakt ist keine Aufwandsentschädigung eingerichtet.',
        notContributor: 'Nur ehrenamtliche Kontakte können eine Aufwandsentschädigung erhalten.',
        notEditable: 'Diese Abrechnung kann nicht mehr geändert werden.',
        notEligible: 'Für diesen Kontakt und Zeitraum kann keine Abrechnung erstellt werden.',
        cadenceLocked:
            'Die Länge des Zeitraums kann nicht geändert werden, solange sich eingereichte Abrechnungen oder Abrechnungen mit Einträgen mit dem aktuellen Zeitraum der neuen Länge überschneiden. Sonst könnte dieselbe Tätigkeit doppelt abgerechnet werden.',
        claimExists: 'Für diesen Kontakt und Zeitraum gibt es bereits eine Abrechnung.',
        invalidClaim: 'Die Abrechnung enthält ungültige Einträge.',
        accountRequired: 'Wähle ein Konto für Auslagen und Korrekturen.',
        accountNotFound: 'Das Konto {{account}} gibt es im Kontenrahmen nicht.',
        rateInUse:
            'Sätze, die Ehrenamtlichen zugeordnet sind, können nicht entfernt werden. Deaktiviere sie stattdessen.',
        limitInUse:
            'Freibeträge mit einem individuellen Betrag bei Ehrenamtlichen können nicht entfernt werden. Entferne den Betrag zuerst bei den Ehrenamtlichen.',
        invalidLimit: 'Wähle einen Freibetrag aus den Einstellungen der Abrechnungen.',
        invalidIndividualLimit: 'Ein individueller Betrag darf den Betrag seines Freibetrags nicht überschreiten.',
        tooManyClaims: 'Wähle höchstens {{count}} Abrechnungen auf einmal aus.',
        tooManyStatements:
            'Bescheinigungen können für höchstens {{count}} Ehrenamtliche auf einmal erstellt werden. Wähle zuerst einen Mandanten.',
        approvalFailed: 'Die Abrechnung konnte nicht freigegeben werden.',
        negativeTotal: 'Abrechnungen mit negativem Gesamtbetrag können nicht freigegeben werden.',
        ownClaim:
            'Du kannst deine eigene Abrechnung nicht freigeben. Das muss eine andere Person mit Freigaberecht übernehmen.',
        missingPayee: 'Für die Auszahlung fehlt eine Bankverbindung.',
        revokeNotPossible:
            'Die Freigabe kann nicht mehr zurückgenommen werden, weil der Beleg bereits bezahlt oder überwiesen wurde. Erfasse stattdessen eine Korrektur in einer späteren Abrechnung.',
        costCenterRequired:
            'Wähle Kostenstelle 1. Der Kontenrahmen verwendet Bereiche, deshalb braucht jeder Beleg eine.',
        invalidCostCenter: 'Wähle eine Kostenstelle des ausgewählten Mandanten.',
        costCenterNotBookable: 'Wähle eine buchbare Kostenstelle eines Deiner Mandanten.',
        fileNotFound: 'Die angehängte Datei wurde nicht gefunden.',
        deadlineInPast: 'Die Frist darf nicht in der Vergangenheit liegen.',
        deadlineRequired: 'Die bisherige Frist ist abgelaufen. Lege eine neue fest.',
        contactDeleted:
            'Der Kontakt der ehrenamtlichen Person wurde gelöscht, daher kann die Abrechnung nicht gebucht werden.',
        payeeNameRequired: 'Gib den Kontoinhaber des Bankkontos an.',
        payeeBicRequired: 'Gib die BIC für ein Bankkonto aus einem anderen Land an.',
        returnMessageRequired: 'Beschreibe, was angepasst werden muss.',
    },
    issues: {
        invalidRate: 'Wähle einen der zugeordneten Sätze.',
        outsidePeriod: 'Das Datum muss im Abrechnungszeitraum liegen.',
        invalidTimeRange: 'Die Endzeit muss nach der Startzeit liegen.',
        timeOverlap: 'Zeiten am selben Tag dürfen sich nicht überschneiden.',
        expensesDisabled: 'Auslagen sind nicht aktiviert.',
        expenseMaxAmount: 'Der Betrag übersteigt das erlaubte Maximum.',
        expenseReceiptRequired: 'Hänge einen Beleg an.',
        payeeRequired: 'Gib die Bankverbindung für die Auszahlung an.',
    },
    notifications: {
        open: 'Abrechnung öffnen',
        review: 'Abrechnung prüfen',
        periodOpenedTitle: 'Deine Abrechnung für {{period}} ist offen',
        periodOpenedMessage: 'Erfasse Deine Zeiten und Auslagen und reiche sie bis {{deadline}} ein.',
        reminderTitle: 'Deine Abrechnung für {{period}} ist fällig',
        reminderMessage: 'Bitte reiche sie bis {{deadline}} ein.',
        submittedTitle: 'Abrechnung prüfen',
        submittedMessage: '{{name}} hat die Abrechnung für {{period}} eingereicht.',
        submittedOnBehalfByMessage:
            '{{submitter}} hat die Abrechnung von {{name}} für {{period}} stellvertretend eingereicht.',
        returnedTitle: 'Deine Abrechnung wurde zurückgegeben',
        returnedMessage:
            'Deine Abrechnung für {{period}} muss angepasst werden. Lies die Hinweise und reiche sie bis {{deadline}} erneut ein.',
        approvedTitle: 'Deine Abrechnung wurde freigegeben',
        approvedMessage: 'Deine Abrechnung für {{period}} über {{amount}} wurde freigegeben.',
        submittedOnBehalfTitle: 'Deine Abrechnung wurde für Dich eingereicht',
        submittedOnBehalfMessage:
            'Deine Organisation hat Deine Abrechnung für {{period}} über {{amount}} in Deinem Namen eingereicht.',
        revokedTitle: 'Die Freigabe Deiner Abrechnung wurde zurückgenommen',
        revokedMessage:
            'Deine Organisation prüft Deine Abrechnung für {{period}} erneut. Lies die Hinweise in der Abrechnung.',
        deadlineChangedTitle: 'Neue Frist für Deine Abrechnung',
        deadlineChangedMessage: 'Bitte reiche Deine Abrechnung für {{period}} bis {{deadline}} ein.',
        changedTitle: 'Deine Abrechnung wurde geändert',
        changedMessage:
            'Deine Organisation hat Deine Abrechnung für {{period}} geändert. Sie beträgt jetzt {{amount}}.',
        paidTitle: 'Deine Abrechnung wurde ausgezahlt',
        paidMessage: 'Deine Organisation hat {{amount}} für Deine Abrechnung für {{period}} ausgezahlt.',
        deletedTitle: 'Deine Abrechnung wurde gelöscht',
        deletedMessage: 'Deine Organisation hat Deine Abrechnung für {{period}} gelöscht.',
        showClaims: 'Abrechnungen anzeigen',
        showDocuments: 'Dokumente anzeigen',
        statementTitle: 'Deine Jahresbescheinigung {{year}} ist verfügbar',
        statementMessage:
            'Deine Organisation hat die Übersicht Deiner Aufwandsentschädigung {{year}} in Deinen Dokumenten geteilt.',
        deadlineTitle: 'Die Einreichungsfrist für {{period}} endet heute',
        deadlineMessage: 'Noch nicht eingereicht: {{notSubmitted}} · Zu prüfen: {{toReview}}',
    },
    export: {
        title: 'Aufwandsentschädigung {{year}}',
        documentsFileName: 'Abrechnungen {{year}}',
        contributor: 'Ehrenamtliche Person',
        approvedClaims: 'Freigegebene Abrechnungen',
        hours: 'Stunden',
        allowance: 'Aufwandsentschädigungen',
        reimbursement: 'Erstattungen',
        payout: 'Freigegebener Betrag',
        limit: 'Freibetrag',
        limitAmount: 'Betrag',
        limitUsed: 'Genutzt',
        limitExempt: 'Steuerfrei',
        limitTaxable: 'Steuerpflichtig',
        openClaims: 'Offene Abrechnungen',
        claim: 'Abrechnung',
        period: 'Zeitraum',
        statusLabel: 'Status',
        type: 'Art',
        date: 'Datum',
        description: 'Beschreibung',
        details: 'Details',
        amount: 'Betrag',
        types: {
            hours: 'Stunden',
            flatRates: 'Pauschale',
            mileage: 'Fahrtkosten',
            expenses: 'Auslage',
            corrections: 'Korrektur',
        },
        status: {
            draft: 'Offen',
            submitted: 'Zu prüfen',
            approved: 'Freigegeben',
        },
    },
    statement: {
        documentName: 'Jahresbescheinigung Aufwandsentschädigung {{year}}',
        title: 'Jahresbescheinigung Aufwandsentschädigung {{year}}',
        provisional: 'Vorläufig',
        provisionalNotice: 'Vorläufig: Für dieses Jahr können noch Abrechnungen eingereicht werden.',
        intro: 'Aufwandsentschädigung für {{name}} im Jahr {{year}}, basierend auf allen freigegebenen Abrechnungen:',
        hours: 'Geleistete Stunden',
        allowance: 'Aufwandsentschädigungen',
        reimbursement: 'Erstattete Fahrtkosten und Auslagen',
        payout: 'Insgesamt freigegeben',
        limitUsage: '{{used}} von {{amount}}',
        limitTaxable: '{{label}}: steuerpflichtiger Anteil',
        footer: 'Erstellt am {{date}}',
    },
    document: {
        contactDocumentName: 'Abrechnung {{number}} ({{period}})',
        fileName: 'Abrechnung {{number}}.pdf',
        title: 'Abrechnung Aufwandsentschädigung',
        number: 'Nummer',
        period: 'Zeitraum',
        contributor: 'Ehrenamtliche Person',
        payee: 'Bankverbindung',
        hours: 'Stunden',
        flatRates: 'Pauschalen',
        mileage: 'Fahrtkosten',
        expenses: 'Auslagen',
        corrections: 'Korrekturen',
        date: 'Datum',
        time: 'Uhrzeit',
        rate: 'Satz',
        quantity: 'Anzahl',
        distance: 'Strecke',
        description: 'Beschreibung',
        participants: 'Teilnehmende',
        amount: 'Betrag',
        total: 'Gesamt',
        limits: 'Freibeträge',
        limit: 'Freibetrag',
        limitClaim: 'Diese Abrechnung',
        limitExempt: 'Davon steuerfrei',
        limitTaxable: 'Davon steuerpflichtig',
        limitYear: 'Genutzt {{year}}',
        limitYearValue: '{{used}} von {{amount}}',
        limitNotice:
            'Stand bei der Freigabe, mit den eingereichten und freigegebenen Abrechnungen des Jahres. Die Jahresbescheinigung berücksichtigt alle freigegebenen Abrechnungen.',
        declaration: 'Erklärung',
        submittedBy: 'Elektronisch eingereicht von {{name}} am {{date}}',
        submittedOnBehalf: 'Von {{name}} stellvertretend eingereicht am {{date}}',
        approvedBy: 'Freigegeben von {{name}} am {{date}}',
        receiptPosition: '{{rate}} – {{period}}',
        expensesPosition: 'Auslagen – {{period}}',
        correctionsPosition: 'Korrekturen – {{period}}',
        receiptDescription: 'Abrechnung Aufwandsentschädigung {{number}}',
        receiptsNotIncluded:
            'Diese Belege konnten hier nicht eingefügt werden und sind bei der Abrechnung gespeichert:',
    },
}
